module.exports = __webpack_public_path__ + "img/Group2.722f87e6.png";